"use client";

import { UserButton } from "@clerk/nextjs";
import { Plug } from "lucide-react";

export function AccountMenuClient({ connectionsEnabled }: { connectionsEnabled: boolean }) {
  return (
    <UserButton appearance={{ elements: { avatarBox: "w-8 h-8" } }}>
      {connectionsEnabled && (
        <UserButton.MenuItems>
          <UserButton.Link
            label="Connections"
            href="/dashboard/connections"
            labelIcon={<Plug className="h-4 w-4" />}
          />
        </UserButton.MenuItems>
      )}
    </UserButton>
  );
}
